import { useInterval } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback } from 'react'

import { DerivedValuesTable } from '@app/components/patient/response-history/response-history-list/derived-values-table'
import { useDerivedValuesForVisit } from '@app/domain/visit/visit.hooks'

interface Props {
  visitId: string
}

export const DerivedValues = ({ visitId }: Props) => {
  const { derivedValues, getDerivedValues } = useDerivedValuesForVisit(visitId)

  const refreshDerivedValues = useCallback(() => {
    getDerivedValues()
  }, [getDerivedValues])

  useInterval(refreshDerivedValues, 2000)

  return <DerivedValuesTable derivedValues={derivedValues} />
}
